import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import Configurator from "@/components/Configurator";
import { PageHero, SectionTitle, CTABand } from "@/components/blocks";
import { STAGES, IMAGES } from "@/data/content";

export default function Reprogrammation() {
  return (
    <div data-testid="reprogrammation-page">
      <Seo title="Reprogrammation moteur | Stage 1, Stage 2, Stage 3 — Horsepower Garage"
        description="Reprogrammation moteur sur mesure : Stage 1, Stage 2 et Stage 3. Cartographie ECU développée et validée au banc de puissance dans le réseau Horsepower."
        canonical="https://www.horsepowergarage.fr/reprogrammation" />
      <PageHero eyebrow="Reprogrammation moteur" title="Reprogrammation sur mesure"
        subtitle="Une cartographie moteur développée pour votre véhicule, jamais un fichier générique. Puissance, couple et fiabilité, validés au banc de puissance."
        image={IMAGES.sportsDark} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 scroll-mt-24">
        <SectionTitle eyebrow="Configurateur" title="Découvrez vos gains" />
        <div className="mt-10"><Configurator /></div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <SectionTitle eyebrow="Nos stages" title="Choisissez votre niveau de préparation" />
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {Object.entries(STAGES).map(([slug, st], i) => (
            <Reveal key={slug} delay={i * 0.08}>
              <div className="hp-card group overflow-hidden h-full flex flex-col">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={st.hero} alt={st.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent" />
                  <span className="absolute bottom-3 left-4 font-display font-black text-3xl uppercase tracking-tight text-hp-yellow">{st.name}</span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <p className="text-sm text-neutral-400 leading-relaxed flex-1">{st.intro}</p>
                  <Link to={`/reprogrammation/${slug}`} className="hp-cta mt-6 px-5 py-3 text-xs inline-flex items-center justify-center gap-2" data-testid={`stage-link-${slug}`}>
                    Découvrir {st.name} <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
